import React from 'react'
import { Row, Col } from 'antd'
import { convertDate2FullDate } from '../../utilities/dateHelper'
import { CloseWebStyled, GlobalCloseWebStyled } from './CloseWebStyled'
const dayjs = require('dayjs')

// แทนที่ตัวแปร {startDate} {endDate} {openDate} ใน closeweb_text ด้วยค่าจริง
const resolveText = (text, configData) => {
  if (!text) return ''
  const startDate = convertDate2FullDate(configData?.closeweb_startdate) || ''
  const endDateTime = configData?.closeweb_enddate
    ? `${convertDate2FullDate(configData?.closeweb_enddate)} เวลา ${dayjs(configData?.closeweb_enddate).format('HH:mm')} น.`
    : ''
  // openDate คือ closeweb_enddate + 1 นาที (เวลาที่ระบบจะกลับมาเปิด)
  const openDateTime = configData?.closeweb_enddate
    ? `${convertDate2FullDate(dayjs(configData?.closeweb_enddate).add(1, 'minute').toISOString())} เวลา ${dayjs(configData?.closeweb_enddate).add(1, 'minute').format('HH:mm')} น.`
    : ''
  return text
    .replace(/{startDate}/g, startDate)
    .replace(/{endDate}/g, endDateTime)
    .replace(/{openDate}/g, openDateTime)
}

const CloseWebComponent = ({ configData }) => {
  const closwebText = resolveText(configData?.closeweb_text || 'ขอแจ้งปรับปรุงระบบ', configData)

  return (
    <>
      <GlobalCloseWebStyled />
      <CloseWebStyled>
        <Row justify="center">
          <Col {...{ xs: 24, md: 24, xl: 24, xxl: 24 }}>
            <div className="form-login">
              <div className="text-closeweb">
                <div dangerouslySetInnerHTML={{ __html: closwebText }} />
              </div>
            </div>
          </Col>
        </Row>
      </CloseWebStyled>
    </>
  )
}

export default CloseWebComponent
